// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Pagination_componentWrapper__Ehxg2"};